import React, { useState } from 'react';
import { Form, Input, Button, message, Select, Divider, Space } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import { UserService } from '../../../Services/Manage/UserService';

const AddProducts = ({ proCat, initialValues, onSubmit, onCancel, getallcat }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();
    const [newCat, setNewCat] = useState("");

    console.log(proCat);


    const handleFinish = async (values) => {
        try {
            const user = await UserService.getOmeUser();

            const payload = {
                ...values,
                added_by: user.uid,
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                added_on: new Date().toISOString().slice(0, 16).replace("T", " ")
            };

            if (initialValues?.id) {
                const req = await ServicetypeService.updateProducts(
                    payload,
                    initialValues.id
                );

                if (req.status) {
                    message.success(req.message);
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message);
                }
            } else {
                const req = await ServicetypeService.createProducts(payload);

                if (req.status) {
                    message.success(req.message);
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message);
                }
            }
        } catch (error) {
            console.error("Service operation failed:", error);
        }
    };

    const addCategory = async () => {
        if (!newCat.trim()) return;

        const request = await ServicetypeService.createProductCat(
            {
                name: newCat,
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            }
        )

        console.log(request);


        if (request.status) {
            getallcat();
            message.success(request.message);
            setNewCat(null)
        } else {
            message.warning(request.message);
        }

        const value = newCat.toLowerCase().replace(/\s+/g, "_");
        getallcat();


    };

    // 🔥 THIS IS THE KEY PART
    const handleValuesChange = (changedValues, allValues) => {
        console.log("Changed:", changedValues);
        console.log("All Values:", allValues);
        // you can store allValues in state if needed
    };

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={initialValues || {}}
            onFinish={handleFinish}
            onValuesChange={handleValuesChange}
        >
            <Form.Item
                name="name"
                label="Product Name"
                rules={[{ required: true, message: 'Please enter product name' }]}
            >
                <Input.TextArea rows={3} size="large" />
            </Form.Item>

            <Form.Item name="sku" label="HSN/SAC Code">
                <Input size="large" />
            </Form.Item>

            <Form.Item name="code_name" label="Product Code Name">
                <Input size="large" />
            </Form.Item>

            <Form.Item name="cat_id" label="Product Category">
                <Select
                    size="large"
                    options={proCat}
                    placeholder="Select category"
                    dropdownRender={(menu) => (
                        <>
                            {menu}
                            <Divider style={{ margin: "8px 0" }} />
                            <Space style={{ padding: "0 8px" }}>

                                <Input
                                    placeholder="Add new category"
                                    value={newCat}
                                    onChange={(e) => setNewCat(e.target.value)}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    size='large'
                                />
                                <Button size='large' type="primary" onClick={addCategory}>
                                    Insert
                                </Button>

                            </Space>
                        </>
                    )}
                />
            </Form.Item>

            <Form.Item name="unit" label="Unit">
                <Input size="large" />
            </Form.Item>

            <Form.Item name="unit_price" label="Unit Price">
                <Input size="large" />
            </Form.Item>

            <Form.Item name="note" label="Note">
                <Input.TextArea rows={3} size="large" />
            </Form.Item>

            <div style={{ textAlign: "right" }}>
                <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size="large">
                    {initialValues?.id ? "Update" : "Add"}
                </Button>
                {messagecontxt}
            </div>
        </Form>
    );
};

export default AddProducts;
